import React, { memo } from 'react';
import { LoadingError } from '../ErrorBoundary';

interface GuideBuilderErrorProps {
  onRetry: () => void;
  message?: string;
}

const GuideBuilderError: React.FC<GuideBuilderErrorProps> = memo(
  ({ onRetry, message = 'Failed to load guide data' }) => {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <LoadingError onRetry={onRetry} message={message} />
      </div>
    );
  },
);

GuideBuilderError.displayName = 'GuideBuilderError';

export default GuideBuilderError;
